import type { CustomIconProps } from '../CustomIcon';

export const BoxIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={3.25} y={2} width={17.5} height={16.25} rx={2} fill={secondaryColor} />
      <rect x={2} y={4} width={20} height={18} rx={2} fill={color} />
      <path d='M8 17h8M8 13h8' stroke={secondaryColor} strokeWidth={1.5} strokeLinecap='round' />
    </svg>
  );
};
